<template>
  <section id="new">
    <h2>更新情報・お知らせ</h2>
    <dl v-for="updateInfo in updateInfoList.slice(-5).reverse()" :key="updateInfo.id">
      <dt>{{ updateInfo.date }}</dt>
      <dd v-html="updateInfo.text"></dd>
    </dl>
    <p class="r">
      &raquo;&nbsp;
      <router-link to="/updateinfodetail">過去ログ</router-link>
    </p>
  </section>
</template>

<script>
export default {
  computed: {
    updateInfoList() {
      // return this.$store.getters.getUpdateInfoList;

      var toDoubleDigits = function(num) {
        num += "";
        if (num.length === 1) {
          num = "0" + num;
        }
        return num;
      };

      var published = this.$store.getters.getUpdateInfoList.filter(function(content) {
        return (content.draft == false);
      });

      var blogPosts = this.$store.getters.getBlogPosts.map(function(content) {
        let dateTime = new Date(content.date);
        var yyyy = dateTime.getFullYear();
        var mm = toDoubleDigits(dateTime.getMonth() + 1);
        var dd = toDoubleDigits(dateTime.getDate());
        var formatted = yyyy + "/" + mm + "/" + dd;
        var dateNumber = "" + yyyy + mm + dd;

        return {
          date: formatted,
          text:
            '<a href="/blog/' + dateNumber +'">'
            + "【ブログ更新】" + content.title + "</a>",
        };
      });

      let result_concat = published.concat(blogPosts);
      result_concat.sort(function(a, b) {
        if (a.date < b.date) return -1;
        if (a.date > b.date) return 1;
        return 0;
      });

      return result_concat;
    },
  },
};
</script>
